import { format } from 'date-fns';
const getFormattedDateForSession = (session) => {
    const dateFormatted = format(new Date(session.VisitDate), 'yyyy-MM-dd');
    return new Date(`${dateFormatted} ${session.StartTime}`);
};
export default getFormattedDateForSession;
